import { ErrorState } from "@bafe/ui";

import { presentError } from "../lib/errors";

export interface ErrorPanelProps {
	error: unknown;
	/**
	 * Context the API cannot know, e.g. "We could not create this mailbox."
	 * The server's own message is kept and moved into the description so no
	 * detail is lost.
	 */
	title?: string;
	onRetry?: () => void;
	retryPending?: boolean;
	className?: string;
}

export function ErrorPanel({ error, title, onRetry, retryPending, className }: ErrorPanelProps) {
	const presented = presentError(error);
	const description = title
		? [presented.title, presented.description].filter(Boolean).join(" ")
		: (presented.description ?? undefined);

	return (
		<ErrorState
			title={title ?? presented.title}
			description={description ?? undefined}
			detail={presented.detail}
			requestId={presented.requestId}
			onRetry={onRetry}
			retryPending={retryPending}
			className={className}
		/>
	);
}
